import { render, staticRenderFns } from "./InstantDataGauge.vue?vue&type=template&id=1685a7ae&"
import script from "./InstantDataGauge.vue?vue&type=script&lang=js&"
export * from "./InstantDataGauge.vue?vue&type=script&lang=js&"
import style0 from "./InstantDataGauge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
